import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { Provider } from 'react-redux';
import store from './Redux/store';
import App from './app';
import Context from 'context/AppContextProvider';
import ContextProvider from 'context/contextProvider';
import { configureLibrary } from '../../../libs/Redux/CoderApis/main.epic';
import { configureApptEpic } from '../../../libs/Redux/Appointment/apt.epic';
import environment from './environments/environment';

const theme = createTheme({
  typography: {
    fontFamily: `Inter, sans-serif`,
  },
  palette: {
    primary: {
      main: '#139696', // Teal color which matches the companies theme
    },
    secondary: {
      main: '#000000', // Grey colour matches sail-gray 300
    },
  },
});

const { baseUrl } = environment;
const { ClinicBaseUrl } = environment;
configureLibrary({
  url: baseUrl,
  clinicUrl: ClinicBaseUrl,
});

configureApptEpic({
  url: baseUrl,
  clinicUrl: ClinicBaseUrl,
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Context components={[ContextProvider]}>
          <App />
        </Context>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
